import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  Star,
  Users,
  Trophy,
  LogOut,
  Menu,
  X,
} from "lucide-react";
import { useState } from "react";

export function TeacherHubHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-lg border-b border-slate-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3">
            <img
              src="/LEcoleDeNaviLogo.png"
              alt="L'ecole de Navi"
              className="h-9 md:h-11 cursor-pointer"
              onClick={() => navigate("/home")}
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-3">
            <button
              data-testid="header-rewards-btn"
              onClick={() => navigate("/rewards")}
              className="flex items-center gap-2 bg-yellow-50 hover:bg-yellow-100 px-3 py-2 rounded-full transition-colors border border-yellow-200"
            >
              <Star className="text-yellow-500 w-4 h-4" fill="currentColor" />
              <span className="font-semibold text-yellow-700 text-sm">12</span>
            </button>

            <button
              data-testid="header-students-btn"
              onClick={() => navigate("/students")}
              className="flex items-center gap-2 bg-blue-50 hover:bg-blue-100 px-3 py-2 rounded-full transition-colors border border-blue-200"
            >
              <Users className="text-blue-600 w-4 h-4" />
              <span className="font-semibold text-blue-700 text-sm">Élèves</span>
            </button>

            <button
              data-testid="header-class-btn"
              onClick={() => navigate("/class")}
              className="flex items-center gap-2 bg-purple-50 hover:bg-purple-100 px-3 py-2 rounded-full transition-colors border border-purple-200"
            >
              <Trophy className="text-purple-600 w-4 h-4" />
              <span className="font-semibold text-purple-700 text-sm">Classe</span>
            </button>

            {/* User Menu */}
            <div className="flex items-center gap-2 bg-slate-100 px-3 py-2 rounded-full ml-2">
              <div className="w-7 h-7 rounded-full bg-indigo-500 flex items-center justify-center">
                <span className="text-white font-bold text-xs">
                  {user?.name?.charAt(0).toUpperCase()}
                </span>
              </div>
              <span className="font-semibold text-slate-700 text-sm max-w-[100px] truncate">
                {user?.name}
              </span>
              <button
                data-testid="header-logout-btn"
                onClick={handleLogout}
                className="p-1 hover:bg-slate-200 rounded-full transition-colors"
                title="Deconnexion"
              >
                <LogOut size={16} className="text-slate-500" />
              </button>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 hover:bg-slate-100 rounded-lg"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden pt-4 pb-2 border-t mt-3 space-y-2">
            <div className="flex items-center gap-2 px-2 py-2 bg-slate-50 rounded-lg mb-3">
              <div className="w-8 h-8 rounded-full bg-indigo-500 flex items-center justify-center">
                <span className="text-white font-bold text-sm">
                  {user?.name?.charAt(0).toUpperCase()}
                </span>
              </div>
              <span className="font-semibold text-slate-700">{user?.name}</span>
            </div>
            
            <button
              onClick={() => { navigate("/rewards"); setMobileMenuOpen(false); }}
              className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-yellow-50 rounded-lg transition-colors"
            >
              <Star className="text-yellow-500 w-5 h-5" fill="currentColor" />
              <span className="font-medium text-slate-700">Recompenses</span>
            </button>
            
            <button
              onClick={() => { navigate("/students"); setMobileMenuOpen(false); }}
              className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-blue-50 rounded-lg transition-colors"
            >
              <Users className="text-blue-600 w-5 h-5" />
              <span className="font-medium text-slate-700">Élèves</span>
            </button>
            
            <button
              onClick={() => { navigate("/class"); setMobileMenuOpen(false); }}
              className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-purple-50 rounded-lg transition-colors"
            >
              <Trophy className="text-purple-600 w-5 h-5" />
              <span className="font-medium text-slate-700">Classe</span>
            </button>
            
            <div className="border-t pt-2 mt-2">
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-red-50 rounded-lg transition-colors text-red-600"
              >
                <LogOut className="w-5 h-5" />
                <span className="font-medium">Deconnexion</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
